import { render } from "./FomoSafeStep.vue?vue&type=template&id=8ce74a56&scoped=true"
import script from "./FomoSafeStep.vue?vue&type=script&lang=js"
export * from "./FomoSafeStep.vue?vue&type=script&lang=js"

import "./FomoSafeStep.vue?vue&type=style&index=0&id=8ce74a56&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce74a56"]])

export default __exports__